export const canUseDOM: () => boolean = () =>
  !!(typeof window !== 'undefined' && window?.document?.createElement);

/**
 * Add a class to body disable scroll
 *
 * @param {Boolean} disable
 */
export const disableGlobalScroll: (disable: boolean) => void = (disable) => {
  if (canUseDOM()) {
    const root = window.document.documentElement; // <html> element

    if (root) {
      if (disable) {
        root.classList.add('noscroll');
      } else {
        root.classList.remove('noscroll');
      }
    }
  }
};

export const getElementTop: (elm: HTMLElement) => number = (elm) => {
  let yPos = 0;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let current: any = elm;
  while (current?.offsetTop !== undefined && current?.clientTop !== undefined) {
    yPos += current.offsetTop + current.clientTop;
    current = current.offsetParent;
  }
  return yPos;
};
